<div *ngIf="text" class="eidos-expandable-text">

    <ng-container *ngIf="!isHtml">
        <ng-container *ngIf="!isTextLong || isTextExpanded ">
            {{text}}
            <span *ngIf="isTextExpanded" class="toggle-expand-text"
                (click)="$event.stopImmediatePropagation(); isTextExpanded = false" style="cursor: pointer;">Less</span>
        </ng-container>

        <ng-container *ngIf="isTextLong && !isTextExpanded">
            {{shortText}}
            <span class="toggle-expand-text"
                (click)="$event.stopImmediatePropagation(); isTextExpanded = true" style="cursor: pointer;">More...</span>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="isHtml">
        <ng-container *ngIf="!isTextLong || isTextExpanded ">
            <div [innerHTML]="text | safeHtml"></div>
            <span *ngIf="isTextExpanded" class="toggle-expand-text"
                (click)="$event.stopImmediatePropagation(); isTextExpanded = false" style="cursor: pointer;">Less</span>
        </ng-container>

        <ng-container *ngIf="isTextLong && !isTextExpanded">
            <div [innerHTML]="truncateText(text) | safeHtml"></div>
            <span class="toggle-expand-text"
                (click)="$event.stopImmediatePropagation(); isTextExpanded = true" style="cursor: pointer;">More...</span>
        </ng-container>
    </ng-container>

</div>
